export default __webpack_public_path__ + "static/media/google_logo.d7f092af.svg";